import { handleRequest } from "../utilities/requestHandler";

export const getSitesByCustomerID = (customerId) =>
    handleRequest("get",`/cus_sites/getsites/${customerId}`);

export const getMachinesBySiteId = ({ site_number, site_id, cus_id, site_line_id }) =>
    handleRequest("post", "/machines/bysiteid", { site_number, site_id, cus_id, site_line_id });

export const getSiteLines = ({ site_number, site_id, cus_id } = {}) => {
    const params = new URLSearchParams();
    if (site_number) params.set("site_number", site_number);
    if (site_id) params.set("site_id", site_id);
    if (cus_id) params.set("cus_id", cus_id);
    const query = params.toString();
    return handleRequest("get", query ? `/machines/site-lines?${query}` : "/machines/site-lines");
};

export const getProvisionedMachines = ({ includeInactive, cus_id, site_id, site_line_id} = {}) => {
    const params = new URLSearchParams();
    if (includeInactive) params.set("include_inactive", "true");
    if (cus_id) params.set("cus_id", cus_id);
    if (site_id) params.set("site_id", site_id);
    if (site_line_id) params.set("site_line_id", site_line_id);
    console.log("cus_id , site_id",site_id, cus_id)
    const query = params.toString();
    const url = query ? `/machines/by-provision?${query}` : "/machines/by-provision";
    return handleRequest("get", url);
};

export const provisionMachinesForCustomerSite = (req_body) =>
    handleRequest("post","/cus_sites/provisionmachines",{table_data: req_body});

export const deleteProvisionsForCustomerSite = (req_body) =>
    handleRequest("post", "/cus_sites/delete-provisions", req_body);

export const updateProvisionForCustomerSite = (id, data) =>
    handleRequest("put", `/cus_sites/provisions/${id}`, data);
